module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kidy-box"
  }, [_c('div', {
    staticClass: "kidy-box-container"
  }, [_c('div', {
    staticClass: "kidy-box-top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/tianjia_20@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleAdd
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.kuaijieduanyu')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kidy-box-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "kidy-box-list-item"
    }, [_c('div', {
      staticClass: "kidy-box-list-item-left"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../assets/image/x_22_1@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.delLiveCommonExpressions(item.id)
        }
      }
    })])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2), _vm._v(" "), (_vm.isKjdyModel) ? _c('div', {
    staticClass: "kjdy-mask"
  }) : _vm._e(), _vm._v(" "), (_vm.isKjdyModel) ? _c('div', {
    staticClass: "kjdy-mask-model",
    on: {
      "click": function($event) {
        _vm.isKjdyModel = false
      }
    }
  }, [_c('div', {
    staticClass: "kjdy-mask-model-rect",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kjdy-mask-model-rect-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xinzengkuaijieduanyu')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kjdy-mask-model-rect-btn",
    on: {
      "click": _vm.addLiveCommonExpressions
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f534b1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kuaijieduanyu/kuaijieduanyu.vue
// module id = 978
// module chunks = 1